import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { SdThemeComponent } from '../../abstract/theme/theme.component';
import { IconSizeEnum } from '../../../_enums/icon.enum';
import { PositionEnum } from '../../../_enums/position.enum';
import { ThemesEnum } from '../../../_enums/themes.enum';
import { SdIconComponent } from '../../icons/icon/icon.component';

@Component({
  selector: '[sd-button-icon]',
  templateUrl: './button-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SdIconComponent]
})
export class SdButtonIconComponent extends SdThemeComponent {
  /**
   * Icon name
   */
  @Input()
  icon = '';

  /**
   * Defined the theme for this icon (light or dark)
   */
  @Input()
  theme: ThemesEnum.light | ThemesEnum.dark | ThemesEnum.invert;

  /**
   * Title to display next to the button icon
   */
  @Input()
  buttonIconTitle: string;

  /**
   * Defined if the title is hidden or not (manage a11Y)
   */
  @HostBinding('class.has-hidden-title')
  @Input()
  titleHidden = true;

  @Input()
  iconPos: PositionEnum.left | PositionEnum.right = PositionEnum.right;

  /**
   * Defined the size of the icon, default: medium
   */
  @Input()
  size: IconSizeEnum = IconSizeEnum.medium;

  @Input()
  isSmall: boolean;

  @Input() class = '';
  @HostBinding('class')
  get hostClasses(): string {
    return [this.class, this.theme ? 'is-theme-' + this.theme : '']
      .filter(Boolean)
      .join(' ');
  }

  positionEnum = PositionEnum;
}
